import { Component, HostListener, Inject, Optional } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GTM } from 'src/app/services/gtm.service';
import { environment } from 'src/environments/environment';
import { MODAL, ModalService } from './services/modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HasUnsavedChanges, UNSAVED_CHANGES_CHECKERS } from './services/interfaces/has-unsaved-changes.interface';
import { ComPlusAdminSecretCommand } from './services/complus-admin/complus-admin-secret-command';
import { ComPlusAdminService } from './services/complus-admin/complus-admin.service';
import { COMPLUS_ADMINISTRATION_ROUTE } from './services/feature-settings/feature-settings-route.constants';

@Component({
  selector: 'ng-casto-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  hideHeader = false;
  private readonly comPlusAdminSecretCommand = new ComPlusAdminSecretCommand();

  @HostListener('window:beforeunload', ['$event'])
  confirmExit(event: BeforeUnloadEvent) {
    if (this.unsavedCheckers?.some(c => c.hasUnsavedChanges())) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  @HostListener('document:keydown.shift.F12', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    this.modalService.display(MODAL.DEBUG_INFOS);
  }

  /** Commande secrète d'accès à l'écran COM+ : sans effet tant que l'API refuse l'accès. */
  @HostListener('document:keydown', ['$event'])
  async handleComPlusAdminSecretCommand(event: KeyboardEvent) {
    if (this.comPlusAdminSecretCommand.handle(event) && (await this.comPlusAdminService.getAccess())) {
      this.router.navigateByUrl('/' + COMPLUS_ADMINISTRATION_ROUTE);
    }
  }

  constructor(
    translate: TranslateService,
    private readonly modalService: ModalService,
    private readonly comPlusAdminService: ComPlusAdminService,
    private router: Router,
    private route: ActivatedRoute,
    public gtm: GTM,
    @Optional() @Inject(UNSAVED_CHANGES_CHECKERS) private unsavedCheckers: HasUnsavedChanges[]
  ) {
    this.router.events.subscribe(() => {
      const currentRoute = this.getDeepestChild(this.route);
      this.hideHeader = currentRoute.snapshot.data['hideHeader'] === true;
    });
    this.gtm.init(environment.tracking);
    translate.setDefaultLang('en');
    let userLang = navigator.language.toLowerCase();
    if (userLang.indexOf('fr') > -1) {
      translate.use('fr');
    }
  }

  private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  get enableErrorPanel(): boolean {
    return environment.sentry.dsn?.length <= 0;
  }
}
